import React from 'react';
import logo from '../assets/img/logo.png'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import {useHistory} from "react-router-dom";
import {LOGIN_URL} from "../Constanta";
import {AuthContext} from "../Context";

const Landing = () => {
    const [authContext, loginState] = React.useContext(AuthContext);

    const history = useHistory();

    const [data, setData] = React.useState({
        passVisible: false,
        eyeIcon: faEyeSlash,
        nik: '',
        password: ''
    })

    const login = async () => {
        let url = LOGIN_URL;
        let payload = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body:
                JSON.stringify({
                    username: data.nik,
                    password: data.password,
                    rememberMe: false
                })
        }

        if (!data.nik.trim() || !data.password.trim()) {
            alert('Oops, sepertinya input anda kosong ')
        } else {
            await fetch(url, payload).then((result) => {
                if (result.status === 200) {
                    result.json().then(resultData => {
                        if (resultData.id_token ) {
                            try {
                                console.log('LOGGED IN')
                                authContext.signIn(data.nik, resultData.id_token);
                                // logIn(resultData.id_token);
                                // history.push('/dashboard');
                            } catch (error) {
                                console.log(error)
                            }
                        }
                        console.log('TABLE DATA : ' + JSON.stringify(resultData.id_token));
                    })
                } else {
                    alert('Maaf, sepertinya kombinasi nik/username dan password anda salah')
                }
            });
        }
    }

    const showHidePassword = () => {
        setData({
            ...data,
            passVisible: !data.passVisible,
            eyeIcon: (data.passVisible ? faEyeSlash : faEye),
        })
    }

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            login();
        }
    }


    return (
        <div className="landing-container">
            <div className="header">
                <img className="header-hero" src={logo} alt="Transjakarta"/>
            </div>
            <div className="landing-login-container">
                <div className="login-title">
                    Kartu Layanan Gratis
                </div>
                <div className="login-form">
                    <label className="login-label" htmlFor="login-nik">NIK</label>
                    <input className="login-input"
                           type="text"
                           id="login-nik"
                           value={data.nik}
                           onChange={e => setData({...data, nik: e.target.value})}
                           onKeyDown={onKeyDown}
                    />
                    <label className="login-label" htmlFor="login-password">Password</label>
                    <div className="login-input-password">
                        <input className="password-input"
                               type={data.passVisible ? "text" : "password"}
                               id="login-password"
                               value={data.password}
                               onChange={e => setData({...data, password: e.target.value})}
                               onKeyDown={onKeyDown}
                        />
                        <FontAwesomeIcon className="password-show"
                                         icon={data.eyeIcon} color="#BDBDBD"
                                         onClick={() => showHidePassword()}/>
                    </div>
                    <div className="login-forgot">Lupa password?</div>
                    <button className="login-button" onClick={() => login()}>Masuk</button>
                    <div className="login-disclaimer">
                        Pastikan <strong>NIK</strong> dan <strong>password</strong> yang telah anda masukan benar
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Landing;
